export const logoLocators = {
  logoIconElement: 'Global-ST-Logo-LogoImage',
} as const;
